import React from "react"
import FormGLClosure from "./Form";

export default function CreateGLClosure() {
  return <FormGLClosure />
}



// WEBPACK FOOTER //
// ./src/components/Accounting/GLClosures/Create.js